/* eslint-disable react-hooks/exhaustive-deps */
import { Header } from "./Header.";
import { TopSection } from "./TopSection";
import { SectionSeparator } from "./SectionSeparator";
import { RecPro } from "./RecPro";
import BasicCard from "./BasicCard";
import Carousel from "better-react-carousel";
import Footer from "./Footer";
import Collection from "./Collection";
import axios from "axios";
import React, { useEffect, useState } from "react";
import CategoryCard from "./CategoryCard";
import pub from "../Images/COVID.jpg";
import "./Styles/index.css";
import "./Styles/preloader.css";
import { Flash } from "./Flash";
import moment from "moment";
import { WhyChooseUs } from "./WhyChooseUs";
import StarredCard from "./StarredCard";
import { getAdById, getAdByIds } from "../Services/Ads";
export const Index = () => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [starredProducts, setStarredProducts] = useState([]);
  const [flashProducts, setFlashProducts] = useState([]);
  const [endAtFlash, setEndAtFlash] = useState("");
  const [recentProducts, setRecentProducts] = useState([]);
  const [collections, setCollections] = useState([]);

  const [showCatego, setShowCatego] = useState(false);

  const [firstAd, setFirstAd] = useState('');
  const [secondAd, setSecondAd] = useState('');
  const [firstMiniAd, setFirstMiniAd] = useState('');
  const [secondMiniAd, setSecondMiniAd] = useState('');
  const [footerAd, setFooterAd] = useState('');
  const [carouselAd, setCarouselAd] = useState([]);

  useEffect(()=>{
    let tmp = getAdById(1);
    
    setFirstAd(tmp.image ? tmp.image : '' )
    
    tmp = getAdById(2)

    setSecondAd(tmp.image ? tmp.image : '' )

    tmp = getAdById(7)

    setFirstMiniAd(tmp.image ? tmp.image : '' )

    tmp = getAdById(8)

    setSecondMiniAd(tmp.image ? tmp.image : '' )

    setCarouselAd(getAdByIds([3,4,5,6]))

    tmp = getAdById(9)

    setFooterAd(tmp.image ? tmp.image : '')

  }, [window.sessionStorage.getItem('ads')])

  function changeShowCateState() {
    setShowCatego(!showCatego);
  }
  useEffect(() => {
    if (window.innerWidth > 770) {
      setShowCatego(false);
    }
  }, [window.innerWidth, showCatego]);
  const [loading, setLoading] = useState(true);
  var isLoad = true;
  var requestsDone = 0;

  axios.interceptors.response.use(function (response) {
    ++requestsDone;

    if (requestsDone == 5) {
      setLoading(false);
    }

    return response;
  });

  useEffect(() => { 
    
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "/api/categories", {
        headers: {
          "x-api-token": process.env.REACT_APP_API_TOKEN,
        },
      })
      .then((a) => {
        setCategories(a.data.filter((x) => x.parent === undefined));
        setSubCategories(a.data.filter((x) => x.parent !== undefined));
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(process.env.REACT_APP_API_BASE_URL + "/custom/starred_products", {
        headers: {
          "x-api-token": process.env.REACT_APP_API_TOKEN,
        },
      })
      .then((x) => {
        setStarredProducts(x.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          "/api/flashes?enable=true&order[createdAt]=desc",
        {
          headers: {
            "x-api-token": process.env.REACT_APP_API_TOKEN,
          },
        }
      )
      .then((x) => {
        for (let i = 0; i < x.data.length; i++) {
          if ((new Date(x.data[i].startAt).getTime() <= new Date().getTime()) && (new Date(x.data[i].endAt).getTime() >= new Date().getTime())) {
            setEndAtFlash(x.data[i].endAt);
            setFlashProducts(x.data[i].flashProducts);

            break;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          "/api/products?order[id]=desc&itemsPerPage=8",
        {
          headers: {
            "x-api-token": process.env.REACT_APP_API_TOKEN,
          },
        }
      )
      .then((b) => {
        setRecentProducts(b.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(process.env.REACT_APP_API_BASE_URL + "/api/product_collections", {
        headers: {
          "x-api-token": process.env.REACT_APP_API_TOKEN,
        },
      })
      .then((c) => {
        let orderedCollections = c.data.sort((a, b) => a.position - b.position);
        setCollections(orderedCollections);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [isLoad]);

  if (!loading) {
    document.getElementById("preloader").classList.add("hide");
    document.querySelector("body").style.overflowY = "scroll";
  }

  return (
    <>
      <div id='preloader' className='loading'>
        <div className='dot'></div>
        <div className='dot'></div>
        <div className='dot'></div>
        <div className='dot'></div>
        <div className='dot'></div>
      </div>
      <Header changeShowCateState={changeShowCateState} />
      <TopSection
        changeShowCateState={changeShowCateState}
        showCatego={showCatego}
        categories={categories}
        subCategories={subCategories}
        leftAd={firstAd}
        rightAd={secondAd}
        firstMiniAd={firstMiniAd}
        secondMiniAd={secondMiniAd}
        carouselAds={carouselAd}
      />
      <WhyChooseUs/>
      {flashProducts.length > 0 ? (
        <Flash
          endAt={moment(endAtFlash)}
          products={flashProducts}
        />
      ) : (
        ""
      )}
      
      <div style={{background: "white", paddingTop: "10px"}}>
      <div>
        <SectionSeparator label='Nos Catégories' />
      </div>
      <div className='section categories-section'>
        <Carousel cols={6} rows={1} gap={3} loop autoplay={3000}>
          {subCategories.map((x, index) => {
            return (
              <Carousel.Item key={"subCategory" + index}>
                <CategoryCard thumb={x.thumb} name={x.name} slug={x.slug} />
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
      </div>

      <div style={{ paddingTop: "15px" }} className='background-kabaa-primary'>
        <SectionSeparator mode='white' label='Produits du moment' />

        <div className='section produits-moment'>
          <Carousel cols={5} rows={1} gap={15} loop autoplay={3000}>
            {starredProducts.map((x, index) => {
              return (
                <Carousel.Item key={"momentProductItem" + index}>
                  <StarredCard   product={x} />
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
      </div>

      <Collection collections={collections} />

      <SectionSeparator label='Produits Récents' />
      <RecPro recentProducts={recentProducts} />
      <div className='footer-pub'>
        <img src={process.env.REACT_APP_ADS_BASE_URL+footerAd} alt="footer-ad" />
      </div>
      <Footer />
    </>
  );
};
